import { render } from "./doughnutChart.vue?vue&type=template&id=39553739&scoped=true&ts=true"
import script from "./doughnutChart.vue?vue&type=script&lang=ts"
export * from "./doughnutChart.vue?vue&type=script&lang=ts"

import "./doughnutChart.vue?vue&type=style&index=0&id=39553739&scoped=true&lang=css"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39553739"]])

export default __exports__